import { Injectable } from "@angular/core"
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router"
import { Observable } from "rxjs"
import { StudentService } from "../services/student.service"

@Injectable({
    providedIn: "root",
})
export class StudentHeroImagesResolver implements Resolve<boolean> {
    constructor(private studentService: StudentService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.studentService.getHeroImages()
    }
}
